define([
  "marionette",
  "jquery",
  "underscore",
  "messaging/messenger",
  "./template/taskLocalesTemplate.html",
  "./template/taskLocaleTemplate.html",
], function (Marionette, $, _, Messenger, TaskLocalesTemplate, TaskLocaleTemplate) {
  "use strict";

  var TaskLocalesView = {};

  TaskLocalesView.localeView = Marionette.ItemView.extend({
    template: TaskLocaleTemplate,
    tagName: "tr",
    className: "task-locale",
    triggers: {
      "click .task-locale-remove-button": "remove:locale",
      "click .remove-all-task-locales-button": "remove:allLocales",
    },
  });

  TaskLocalesView.localesView = Marionette.CompositeView.extend({
    className: "row-fluid",
    template: TaskLocalesTemplate,
    itemView: TaskLocalesView.localeView,
    itemViewContainer: "tbody",
    triggers: {
      "click .add-task-locales-button": "add:locales",
      "click .remove-all-task-locales-button": "remove:allLocales",
    },
    getSelectedLocales: function () {
      var values = $(".task-locales-select-locale", this.$el).val();
      if (!values) {
        return [];
      }
      return _.map(values, function (v) {
        return +v;
      });
    },
  });

  return TaskLocalesView;
});
